export default function getPreviewImages(product) {
  if (product?.previewImages && product?.previewImages?.length) {
    return product?.previewImages;
  }
  return [];
}
